/*** IMPORTS FROM imports-loader ***/
var define = false;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function challengeAnimations() {
  // alert('firing');
  var citiesTL = gsap.timeline({
    scrollTrigger: {
      trigger: '.description',
      pin: '.description',
      pinSpacing: false,
      start: "top 30%",
      // markers: true,
      endTrigger: '.cities',
      end: 'bottom 50%'
    },
  });

  gsap.to('.intro', {
    scrollTrigger: {
      trigger: ".intro",
      start: 'top 100px',
      end: 'top 0px',
      // markers: true,
      scrub: 1,
    },
    opacity: 0,
  });

  gsap.to('.description', {
    scrollTrigger: {
      trigger: ".intro",
      start: 'top 50px',
      endTrigger: ".description",
      end: 'top 200px',
      scrub: 1,
      // markers: true
    },
    opacity: 1
  });

  // gsap.to('.opportunities', {
  //   scrollTrigger: {
  //     trigger: ".description",
  //     start: 'bottom 150px',
  //     endTrigger: ".opportunities",
  //     end: 'top 200px',
  //     scrub: 1,
  //     // markers: true
  //   },
  //   opacity: 1
  // });

  // gsap.to('.opportunities--inner', {
  //   scrollTrigger: {
  //     trigger: ".opportunities",
  //     start: 'top 50%',
  //     // endTrigger: ".opportunities",
  //     // end: 'top 200px',
  //     // scrub: 1,
  //     markers: true
  //   },
  //   opacity: 1,
  //   duration: .3
  // });

  ScrollTrigger.batch(".challenges__challenge", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, {
        opacity: 1,
        scrollTrigger: {
          trigger: elements[0],
          scrub: 1,
          start: 'top 70%',
          end: 'top 40%',
          toggleActions: "restart pause resume reverse"
        }
      });
    }
  });

  gsap.to('.challenges__link--one', {
    scrollTrigger: {
      trigger: ".challenges__challenge--one",
      toggleClass: {targets: ".challenges__link--one", className: "inView"},
      start: 'top bottom',
      // markers: true
    }
  });

  gsap.to('.challenges__link--two', {
    scrollTrigger: {
      trigger: ".challenges__challenge--two",
      toggleClass: {targets: ".challenges__link--two", className: "inView"},
      start: 'top 40%',
      // markers: true
    }
  });

  gsap.to('.challenges__link--three', {
    scrollTrigger: {
      trigger: ".challenges__challenge--three",
      toggleClass: {targets: ".challenges__link--three", className: "inView"},
      start: 'top 40%',
      // markers: true
    }
  });

  gsap.to('.challenges__link--four', {
    scrollTrigger: {
      trigger: ".challenges__challenge--four",
      toggleClass: {targets: ".challenges__link--four", className: "inView"},
      start: 'top 40%',
      // markers: true
    }
  });

  gsap.to('.challenges__link--five', {
    scrollTrigger: {
      trigger: ".challenges__challenge--five",
      toggleClass: {targets: ".challenges__link--five", className: "inView"},
      start: 'top 40%',
      // markers: true
    }
  });

  gsap.to('.challenges__link--six', {
    scrollTrigger: {
      trigger: ".challenges__challenge--six",
      toggleClass: {targets: ".challenges__link--six", className: "inView"},
      start: 'top 40%',
      // markers: true
    }
  });
}
